export class GetBorrowerStatusReasons {
	static readonly type = '[BorrowerStatusReason] GetBorrowerStatusReasons';
	constructor() {}
}
